import { Fragment, useState} from "react";
import { Button } from "@material-tailwind/react";
import {FilterFunction} from './FilterFunction';
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  } from "@tanstack/react-table";
import { cardColors } from './constants';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export const BasicExamTable = ({data,columns}) => {
  const [columnFilters,setColumnFilters] = useState([]);
  const [sorting, setSorting]=useState([]);
  const [filtering, setFiltering]=useState('')
  const dateFormatFn = (v_date) => {
    if (!v_date) return null; // Prevent undefined errors
    const dateObj = new Date(v_date)
    if (v_date.length <= 10)
      return dateObj.toLocaleDateString("en-GB", { month: "short", day: "2-digit", year: "2-digit" });
    else
      return dateObj.toLocaleDateString("en-GB",{ month: "short", day: "2-digit", year: "2-digit"} ) + " " + dateObj.toLocaleTimeString("en-GB", { hour:'numeric', minute:'numeric', hour12: true }).toUpperCase();
  };
  

  function getCardColors(index) {
    return cardColors[index % cardColors.length];
  }
  // const buttonCSS = "px-6 py-1 gap-x-4 rounded-lg text-lg font-nunito font-semibold \
  //                   border-blue-400 bg-white text-black normal-case \
  //                   hover:bg-primary-500 hover:text-white"
  const buttonCSS = "m-2 p-2 h-10 w-fit \
                      bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 \
                      border-2 rounded-lg \
                      text-base font-bold tracking-widest normal-case items-center"
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      columnFilters,
      sorting: sorting,
      globalFilter:filtering,
    },
    onColumnFiltersChange:setColumnFilters,
    onSortingChange:setSorting,
    onGlobalFilterChange:setFiltering,
    
  });

  function getFirstAndLastDate(value) {
    // Helper function to convert 'dd MMM yy' → 'YYYY-MM-DD'
    const parseCustomDate = (dateStr) => {
        const match = dateStr.match(/^(\d{1,2}) (\w{3}) (\d{2})$/);
        if (match) {
            let [_, day, month, year] = match;
            const months = {
                Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
                Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
            };
            year = `20${year}`; // Convert '25' → '2025'
            return `${year}-${months[month]}-${day.padStart(2, "0")}`;
        }
        return null; // Invalid format
    };

    let dateCount = [];
    let firstDate = null;
    let lastDate = null;

    if (value) {
        const valueDates = value.split(",\n")
        dateCount = valueDates.length
        if ( dateCount > 0) {
          firstDate = !isNaN(Date.parse(valueDates[0])) ? valueDates[0] : null
          lastDate = dateCount > 1 && !isNaN(Date.parse(valueDates[dateCount - 1])) ? valueDates[dateCount - 1] : null;
        } else {
          const valueDate = !isNaN(Date.parse(value)) 
          if (valueDate) {
              firstDate = new Date(value.trim());
          } 
        }
    }
    return [firstDate, lastDate];
  }

  function defaultActivityStatus() {
    return {
      fgcolor: "",
      bgcolor: "bg-transparent",
      textcolor: "text-white",
      bordercolor: "text-secondary-900",
      statusText: "",
    };
  }
  const activityStatus = (value) => {
      let statusText = '';
      let bgcolor = "bg-transparent";
      let fgcolor = "text-white";
      let textcolor = "text-secondary-900";
      let bordercolor = ''
      let effectiveDate;
      let endPart;
      let endDate;
      let diffDays;
      const today = new Date(); // default date in UTC
      const valueTOform = (/\bto\b/.test(value)) // Value has /nto/n or simply to

      if (valueTOform) {
          [effectiveDate, endPart] = value.split(/\bto\b/).map(d => d.trim());
          // Split endPart into individual dates (handling extensions)
          let endDates = endPart.split("\n").map(d => {
            // Extract the date part (before any remark in parentheses)
            let datePart = d.split(" (")[0].trim();
            datePart = new Date(datePart);
            return datePart;
          });
            
          // Extract latest date without modifying time
          let latestEndDate = endDates.reduce((latest, current) => 
              current > latest ? current : latest, endDates[0]);

          endDate = latestEndDate; // Assign directly without creating a new Date object
          // Convert effectiveDate to Date object
      } else {// value can be any text string or an array of dates or a string with a single date.
          [effectiveDate, endDate] = getFirstAndLastDate(value)
          endDate = endDate? new Date(endDate): null
      } 
      effectiveDate = effectiveDate? new Date(effectiveDate): null

      if ((endDate) && (endDate instanceof Date) && !isNaN(endDate)) {
          diffDays = Math.floor((today - endDate) / (1000 * 60 * 60 * 24)); // Difference in days
          if (today <= endDate) { //endDate has not passed
              if (effectiveDate instanceof Date && !isNaN(effectiveDate)) {
                  if ((today >= effectiveDate) ) {
                      statusText = "Ongoing!";
                      bgcolor = "bg-warning-500"; // Orange for coming soon
                  };
                };
          } else if (today > endDate) { // endDate has passed.
                statusText = "Closed!";
                fgcolor = "text-danger-500";
                textcolor="text-gray-400";
                bordercolor = "border-danger-500"
          } else if (diffDays === 0) { // endDate is today
              statusText = "Due Today!";
              bgcolor = "bg-warning-500"; // Orange for coming soon
          } else if (diffDays < 0 && diffDays > -7) { // 7 days to due date
              statusText = "Due Soon!";
              bgcolor = "bg-info-900"; // Orange for coming soon
          };
      } else if (effectiveDate && effectiveDate instanceof Date && !isNaN(effectiveDate)) {
          diffDays = Math.floor((today - effectiveDate) / (1000 * 60 * 60 * 24)); // Difference in days
          console.log(diffDays)
          if (diffDays > 0) { // The date has passed by
              statusText = "Closed!";
              fgcolor = "text-danger-500";
              textcolor="text-gray-400";
              bordercolor = "border-danger-500"
          } else if (diffDays === 0) {
              statusText = "Due Today!";
              bgcolor = "bg-warning-900"; // Orange for Expiring today
          } else if (diffDays < 0 && diffDays > -7) { // 7 days to due date
              statusText = "Due Soon!";
              bgcolor = "bg-info-900"; // Orange for coming soon
          };
          // value is between start and end date
      };
    return {fgcolor, bgcolor, textcolor, bordercolor,statusText}
  };
  
  // Helper function to render exam card
  const renderExamCard = (row, index) => {
    const visibleCells = row.getVisibleCells();
    const headerGroups = table.getHeaderGroups();
    const colors = getCardColors(index);
    
    return (
      <div className={`${colors.bg} border-2 ${colors.border} 
                       rounded-xl shadow-lg hover:shadow-xl 
                       transition-shadow duration-300 
                       p-5 space-y-3 h-full flex flex-col text-center 
                       w-full max-w-full overflow-hidden min-w-0`}>
        {/* Exam Schedule Details */}
        {visibleCells.map((cell) => {
          // Find the header for this cell's column
          const columnId = cell.column.id;
          let header = null;
          
          // Search through all header groups to find the matching header
          for (const headerGroup of headerGroups) {
            // First, try to find in leaf headers
            header = headerGroup.headers.find(h => h.column.id === columnId);
            if (header) break;
            
            // If not found, search in nested headers
            for (const h of headerGroup.headers) {
              if (h.subHeaders) {
                header = h.subHeaders.find(sh => sh.column.id === columnId);
                if (header) break;
              }
            }
            if (header) break;
          }
          
          // Fallback to column definition header
          if (!header) {
            header = { column: { columnDef: cell.column.columnDef } };
          }
          
          const { fgcolor, bgcolor, textcolor, bordercolor, statusText } = cell.column.columnDef.custom_getActivityStatus ? activityStatus(cell.getValue()) : defaultActivityStatus();  
          
          
          // Get header text
          const headerText = header ? flexRender(header.column.columnDef.header, header.getContext()) : cell.column.columnDef.header || '';
          
          // Check if this is the first column
          const isFirstColumn = visibleCells.indexOf(cell) === 0;
          
          return (
            <div key={cell.id} className={`border-b ${colors.border} 
            pb-3 last:border-b-0 last:pb-0`}>
              {headerText !== 'Exam Name' && (
                <div className={`font-bold ${colors.text} mb-2 text-center ${colors.accent} rounded-lg py-2 px-3 text-sm md:text-base uppercase tracking-wide`}>
                  {headerText}
                </div>
              )}
              <div className={`${isFirstColumn ? 
                               'text-xl md:text-2xl font-bold text-tertiary-300' : 
                               `${textcolor} text-base md:text-lg 
                               font-medium`} font-nunito text-center break-words`}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </div>
              {statusText && (
                <div className={`${bgcolor} ${fgcolor} border ${bordercolor} 
                     mt-2 text-sm md:text-base text-center font-bold rounded-md 
                     px-3 py-1.5 shadow-sm font-nunito`}>
                  {statusText}
                </div>
              )}
            </div>
          );
        })}
        
        {/* Extra Notes */}
        {row.original.edt_examdates_remarks && (
          <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
              ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
            <span className="font-semibold">📌 Exam Dates:</span> {row.original.edt_examdates_remarks}
          </div>
        )}
        {row.original.edt_notes && (
          <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
            ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
            <span className="font-semibold">📌 Notes:</span> {row.original.edt_notes}
          </div>
        )}
        {row.original.edt_application_remarks && (
          <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
            ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
            <span className="font-semibold">📌 Application Dates:</span> {row.original.edt_application_remarks}
          </div>
        )}
        {row.original.edt_city_intimation_date ? (
          <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
            ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
            <span className="font-semibold">📌 City Intimation:</span> {dateFormatFn(row.original.edt_city_intimation_date)}
          </div>
        ) : row.original.edt_city_intimation_remarks && (
          <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
            ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
            <span className="font-semibold">📌 City Intimation Notes:</span> {row.original.edt_city_intimation_remarks}
          </div>
        )}
        {row.original.edt_exam_shifts && (
          <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
            ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
            <span className="font-semibold">📌 Shift Timings:</span> {row.original.edt_exam_shifts}
          </div>
        )}
      </div>
    );
  };

  return (
    <Fragment>
      
      <div className="w-full max-w-full overflow-hidden px-2 sm:px-4 py-4">
        <div className="w-full max-w-full relative">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            slidesPerGroup={1}
            navigation={true}
            pagination={{ clickable: true }}
            watchOverflow={true}
            breakpoints={{
              1024: { // lg - laptop/desktop
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 20,
              },
            }}
            className="exam-carousel-swiper"
            style={{ width: '100%', maxWidth: '100%' }}
            onSwiper={(swiper) => {
              // Force update on mount after a short delay
              setTimeout(() => {
                if (swiper && swiper.update) {
                  swiper.update();
                }
              }, 100);
            }}
          >
          {table.getRowModel().rows.map((row, index) => (
            <SwiperSlide key={row.id} className="h-auto">
              <div className="w-full h-full">
                {renderExamCard(row, index)}
              </div>
            </SwiperSlide>
          ))} 
          </Swiper>
        </div>
      </div>
    </Fragment>
  );
};
